<template>
  <input
    v-model="context.model"
    v-bind="context.attributes"
    readonly
    :input-class="context.attributes.class"
    :data-type="context.type"
    type="password"
    @focus="onFocus"
    @blur="onBlur"
    @touchstart="onTouchStart"
  >
</template>
<script>
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'FormulateOskTextPassword',

  components: {},

  props: {
    context: {
      type: Object,
      required: true,
    },
    oskType: {
      type: String,
      default: 'default',
    },
  },

  computed: {
    ...mapState('app/simpleKeyboard', ['currentInputValue']),
  },

  watch: {
    currentInputValue(newValue) {
      if (this.$el.contains(document.activeElement)) {
        this.context.model = newValue
      }
    },
  },

  methods: {
    ...mapActions('app/simpleKeyboard', ['showKeyboard', 'hideKeyboard']),

    // necessário para impedir teclado nativo
    onTouchStart(event) {
      event.preventDefault()

      this.showKeyboard({
        el: event.target,
        layoutType: this.oskType,
      })
    },

    // eslint-disable-next-line func-names
    onFocus: _.debounce(async function (event) {
      this.showKeyboard({
        el: event.target,
        layoutType: this.oskType,
      })
      this.$emit('focus', event.target.value, event)
    }, 50),

    onBlur() {
      this.hideKeyboard()
    },
  },
}
</script>
